import { Api } from 'lib/api.mjs';

/**
 * Affiliate logins. Admin only.
 *
 * Create and update use the explicit form so a rejected username can be shown
 * instead of disappearing into a null.
 */

export function list({ signal } = {}) {
  return Api.get('/affiliates', { signal });
}

export function create(payload) {
  return Api.postV2('/affiliates', { body: payload });
}

export function update({ id, changes }) {
  return Api.patchV2(`/affiliates/${id}`, { body: changes });
}

export function telegramCode({ id }) {
  return Api.postV2(`/affiliates/${id}/telegram-code`, { body: {} });
}
